import { gridStoreResults } from 'fox-react/dist/components/FoxGrid/actions';
import gridNames from 'common/gridNames';
import CarTypesManagementSrv from './CarTypesManagementSrv';

export function storeResults(results) {
  return gridStoreResults(gridNames.carTypesManagement)(results);
}

export function getForGrid(dataState) {
  return function(dispatch) {
    return CarTypesManagementSrv.getForGrid(dataState).then(results => {
      dispatch(storeResults(results));
    });
  };
}

export function addAsync(model) {
  return function() {
    return CarTypesManagementSrv.add(model);
  };
}

export function updateAsync(model) {
  return function() {
    return CarTypesManagementSrv.update(model);
  };
}
